// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';
// import reportWebVitals from './reportWebVitals';
// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import ScamSenseApp from './ScamSenseApp';

// GMI build: mount ScamSenseApp (GMI branding, free-tier quota headers, key
// modal) instead of the upstream App.js. App.js gated the whole product behind
// <GoogleLogin> using the upstream author's hardcoded OAuth client ID, whose
// authorized JavaScript origins we don't control — on any new host that fails
// with "Error 400: origin_mismatch" and nothing is reachable. ScamSenseApp
// needs no sign-in: identity is a localStorage client id (x-client-id).
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ScamSenseApp />
  </React.StrictMode>
);